import list_icon from '@/assets/img/device/nd68/icon.png'
import { Mars68 } from './mars68.ts'

export class Mars68_Wireless_24g extends Mars68 {
  name: string = 'Mars68_Wireless'
  icon: string = list_icon
  width: number = 640

  // 30 秒
  // 2 分钟
  // 5 分钟
  // 15 分钟
  // 30 分钟
  // 1 小时
  // 2 小时
  // 4 小时
  // 8 小时
  // 12 小时
  // 18 小时
  sleepTimeValues = [0, 30, 2 * 60, 3 * 60, 5 * 60, 15 * 60, 30 * 60, 1 * 60 * 60, 2 * 60 * 60, 4 * 60 * 60, 8 * 60 * 60, 12 * 60 * 60, 18 * 60 * 60]
  sleepTimeBTValues = this.sleepTimeValues
}
